
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clinical-and-intervention-services-department",
      function () {
        return require("private-next-pages/clinical-and-intervention-services-department.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clinical-and-intervention-services-department"])
      });
    }
  